import { render, staticRenderFns } from "./QApplicationsTable.vue?vue&type=template&id=d961fbd0&scoped=true&"
import script from "./QApplicationsTable.vue?vue&type=script&lang=js&"
export * from "./QApplicationsTable.vue?vue&type=script&lang=js&"
import style0 from "./QApplicationsTable.vue?vue&type=style&index=0&id=d961fbd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d961fbd0",
  null
  
)

export default component.exports